import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { getDateFormat } from '../../_helpers/useful-functions';
import Spinner from '../../components/ui/spinner';
import { useAppSelector } from '../../store';
import { downloadMomentReportsExcel, setFilterOpen } from '../../store/features/moments-reports/momentReportsSlice';
import FilterModal from './FilterModal';
import { ReactComponent as ExcelIcon } from '../../_assets/images/excel.svg';
import { CircularProgress } from '@material-ui/core';

const FilterSection = () => {
    const dispatch = useDispatch();
    const [isOpenFilterModal, setIsOpenFilterModal] = useState<boolean>(false);
    const [companyText, setCompanyText] = useState<string>('');
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [reportRole, setReportRole] = useState<number>()

    const { startDate, endDate, companyNameList } = useAppSelector(state => state.momentReports.yellowWarning);
    const { info } = useAppSelector(state => state.users);
    const { companyAllListWithLabelValue, dasboardFeed, momentReportsMenuList, gridTableGroupTitle, reportFilter } = useAppSelector(state => state.momentReports);

    const filterModalChange = () => {
        setIsOpenFilterModal(true);
        dispatch(setFilterOpen(true));
    };
    useEffect(() => {
        setReportRole(info?.userInfo?.reportRole)
    }, [info?.userLoading])
    

    useEffect(() => {
        let text = '';
        if (
            (reportRole !== 1 && companyNameList?.length > 0 &&
                companyNameList?.length === companyAllListWithLabelValue?.items?.length &&
                companyAllListWithLabelValue?.items?.length !== 1) ||
            (companyNameList?.length === 0 && companyAllListWithLabelValue?.items?.length > 1 && reportRole !== 1)
        ) {
            text = 'Koç Holding bünyesindeki tüm şirketlerin ';
        } else if (companyAllListWithLabelValue?.items?.length === 1) {
            text = `${companyAllListWithLabelValue?.items[0]?.label} ` + ' firmalarının ';
        } else if (companyNameList?.length <= 3 && companyNameList?.length > 0) {
            text =
                `${companyNameList?.[0]}${companyNameList[1] ? ', ' + companyNameList?.[1] : ''} ${companyNameList[2] ? ', ' + companyNameList?.[2] : ''
                } ` + ' firmalarının ';
        } else if (companyNameList?.length > 3 && companyAllListWithLabelValue?.items?.length > 3) {
            text =
                `${companyNameList?.[0]}${companyNameList[1] ? ', ' + companyNameList?.[1] : ''} ${companyNameList[2] ? ', ' + companyNameList?.[2] : ''
                } ` + ' ve diğer firmaların ';
        } else if (companyNameList?.length === 0 && companyAllListWithLabelValue?.items?.length > 3 && reportRole === 1) {
            text =
                `${companyAllListWithLabelValue?.items[0]?.label}${companyAllListWithLabelValue?.items[1] ? ', ' +companyAllListWithLabelValue?.items[1]?.label : ''} ${companyAllListWithLabelValue?.items[2] ? ', ' + companyAllListWithLabelValue?.items[2]?.label : ''
                } ` + ' ve diğer firmaların ';
        } else if (companyNameList?.length === 0 && companyAllListWithLabelValue?.items?.length <= 3 && reportRole === 1) {
            text =
                `${companyAllListWithLabelValue?.items[0]?.label}${companyAllListWithLabelValue?.items[1] ? ', ' +companyAllListWithLabelValue?.items[1]?.label : ''} ${companyAllListWithLabelValue?.items[2] ? ', ' + companyAllListWithLabelValue?.items[2]?.label : ''
                } ` + ' firmalarının ';
        } else {
            return;
        }

        setCompanyText(text);
    }, [companyNameList, companyAllListWithLabelValue]);

    const handleDownload = async () => {
        setIsLoading(true);

        await dispatch(
            downloadMomentReportsExcel({
                startDate: getDateFormat({ date_: reportFilter?.startDate }),
                endDate: getDateFormat({ date_: reportFilter?.endDate }),
                companyIdList: reportFilter?.companyIdList,
                reportLeftMenuDetailsType: gridTableGroupTitle?.excelType,
            })
        );
        setIsLoading(false);
    };    

    return (
        <>
            <FilterModal setIsOpenFilterModal={setIsOpenFilterModal} isOpenFilterModal={isOpenFilterModal} />
            <div className="c-item-filter">
                <button className="c-unit-01" disabled={dasboardFeed?.loading || momentReportsMenuList?.loading} onClick={() => filterModalChange()}>
                    <svg className="c-unit-01-A" xmlns="http://www.w3.org/2000/svg" width="16.58" height="16.58" viewBox="0 0 16.58 16.58">
                        <g data-name="Group 11820">
                            <path
                                data-name="Path 32"
                                d="M15.543-16.625H1.038A1.037 1.037 0 0 0 .3-14.856l5.918 5.914v6.047a1.033 1.033 0 0 0 .354.78L8.644-.3a1.037 1.037 0 0 0 1.719-.78v-7.86l5.913-5.914a1.037 1.037 0 0 0-.733-1.771zM9.326-9.371v8.29L7.254-2.894v-6.477l-6.218-6.218h14.508z"
                                transform="translate(0 16.625)"
                                fill="#2f3440"
                            />
                        </g>
                    </svg>

                    <span className="c-unit-01-B">Filtre</span>
                </button>

                <button
                    className="c-unit-02"
                    onClick={handleDownload}
                    disabled={isLoading}
                >
                    {isLoading ? <CircularProgress size={20} className='text-white' /> : <ExcelIcon />}
                    <span className="c-unit-02-A">
                        {isLoading ? "Excele Aktarılıyor" : "Excele Aktar"}
                    </span>
                </button>
            </div>

            <div className="c-item-filter-text-body">
                {companyAllListWithLabelValue?.items?.length > 0 ? (
                    <p className="filter-text">
                        <strong>
                            {/* {companyAllListWithLabelValue?.items?.length === 1
                                ? companyAllListWithLabelValue?.items[0]?.label + ' ' + 'firmalarının '
                                : companyText} */}

                            {companyText}
                        </strong>
                        {startDate && endDate && (
                            <span className="date-text-group">
                                <span className="text-bold">
                                    {getDateFormat({ date_: startDate, seperator: '.', beginningDate: 'day' })} -{' '}
                                    {getDateFormat({ date_: endDate, seperator: '.', beginningDate: 'day' })}
                                </span>
                                tarihleri aralığındaki
                            </span>
                        )}
                        verilerini görüntülemektesiniz.
                        <br />
                        Daha fazlasını görmek için <span className="text-bold">Filtre</span>’yi kullanabilirsiniz.
                    </p>
                ) : (
                    <Spinner />
                )}
            </div>
        </>
    );
};

export default FilterSection;
